import { CatalogRequestParams } from '@/src/lib/category/types';
import { hydrateArrayParams, hydrateIsAvailableParam } from '@/src/lib/search-params/business/search-params';
import { CatalogSearchRequestParams } from '@/src/lib/catalog-search/types';

export function getHydratedCategoryTreesParams(lang: string, params: CatalogSearchRequestParams = {}) {
  const queryParams = JSON.parse(JSON.stringify({ ...params, lang }));
  let searchParams = new URLSearchParams(queryParams);

  filterBlockedParams(searchParams);
  searchParams = hydrateIsAvailableParam(searchParams);

  searchParams = hydrateArrayParams(searchParams);

  return `?${searchParams.toString()}`;
}

export function filterBlockedParams(searchParams: URLSearchParams) {
  searchParams.delete(CatalogRequestParams.SORT);
  searchParams.delete(CatalogRequestParams.IPP);
  searchParams.delete(CatalogRequestParams.PAGE);
  searchParams.delete(CatalogRequestParams.CURRENCY);

  return searchParams;
}
